export default {
  page: "Product",
  cart: [],
  items: {
    Men: [
      {
        sys: { id: "1" },
        fields: {
          title: "Jacket",
          price: 35.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-1.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-1.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-7.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-1.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "2" },
        fields: {
          title: "Jean",
          price: 55.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-30.jpg?raw=truee"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-31.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-33.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-32.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-30.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "3" },
        fields: {
          title: "Leather Jacket",
          price: 119.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-2.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-6.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "4" },
        fields: {
          title: "Black Eyeglasses",
          price: 9.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-3.jpg?raw=trueg"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-3.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "5" },
        fields: {
          title: "Grey Pant",
          price: 22.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-4.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-4.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-4.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-4.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-4.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "6" },
        fields: {
          title: "White Tshirt",
          price: 33.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-8.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-8.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-8.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-8.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-8.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "7" },
        fields: {
          title: "Black Jean",
          price: 92.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-6.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-6.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "8" },
        fields: {
          title: "Kaki pant",
          price: 45.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-7.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-1.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-1.jpg?raw=true"
              ]
            }
          }
        }
      }
    ],
    Women: [
      {
        sys: { id: "1" },
        fields: {
          title: "Red Top",
          price: 79.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-37.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-36.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-35.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-35.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-36.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "2" },
        fields: {
          title: "White Flower Dress",
          price: 100.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-1.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wgallery12.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-9.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-1.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-9.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "3" },
        fields: {
          title: "Red Top",
          price: 120.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-2.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wgellery21.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wgellery21.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-2.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "4" },
        fields: {
          title: "Short",
          price: 55.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-3.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-10.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-10.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "5" },
        fields: {
          title: "White Top",
          price: 69.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-4.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-11.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-4.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-11.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-4.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "6" },
        fields: {
          title: "Women Accessories",
          price: 88.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-5.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-5.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "7" },
        fields: {
          title: "Dress",
          price: 50.0,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-6.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-6.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "8" },
        fields: {
          title: "Ananas",
          price: 45.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-7.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-7.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-7.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-7.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-7.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "9" },
        fields: {
          title: "Jean Dress",
          price: 79.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-8.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-8.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-8.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-8.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-8.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "10" },
        fields: {
          title: "Jean",
          price: 79.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-30.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-31.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-30.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-30.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-31.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "11" },
        fields: {
          title: "Jean",
          price: 79.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-33.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-32.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-34.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-33.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-42.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "13" },
        fields: {
          title: "Leather Jacket",
          price: 100.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-39.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wgallery12.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-9.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-39.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-39.jpg?raw=true"
              ]
            }
          }
        }
      }
    ],
    Kids: [
      {
        sys: { id: "1" },
        fields: {
          title: "Dress",
          price: 12.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-1.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-1.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-1.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-1.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-1.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "2" },
        fields: {
          title: "Girls Dress",
          price: 8.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-2.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-2.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-2.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "3" },
        fields: {
          title: "Eyeglasses",
          price: 16.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-3.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-3.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-3.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "4" },
        fields: {
          title: "Girl Dress",
          price: 59.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-4.jpg?raw=trueg"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-4.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-4.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-4.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-4.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "5" },
        fields: {
          title: "Black pant",
          price: 88.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-5.jpg?raw=trueg"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-5.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-5.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "6" },
        fields: {
          title: "Set Short Shirt",
          price: 5.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-6.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-6.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-6.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "7" },
        fields: {
          title: "Pant",
          price: 45.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-7.jpg?raw=trueg"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-7.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-7.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-7.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-7.jpg?raw=true"
              ]
            }
          }
        }
      },
      {
        sys: { id: "8" },
        fields: {
          title: "White Dress",
          price: 33.99,
          image: {
            fields: {
              file: {
                url:
                  "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-9.jpg?raw=true"
              },
              gal: [
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-9.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-9.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-9.jpg?raw=true",
                "https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-9.jpg?raw=true"
              ]
            }
          }
        }
      }
    ]
  }
};
